import { create } from 'zustand';
export const useSegmentAnalyticsStore = create(() => ({
    client: undefined
}));
//# sourceMappingURL=useSegmentAnalyticsStore.js.map